import { newArray } from '@angular/compiler/src/util';

export class GridParameters {
    table: string;
    skip: number;
    top: number;
    order: string = "";
    filter: string = "";
    defaultFilter: string = "";
    newGroupAmount = 100;
    dataLength: number = 0;
    dataSource: any;
    newData = [];
    orderColumns = [];
    orderColumnsArrow = [];
    canGetData: boolean = true;
    parameterUrlOld: string = "";
    parameterUrlNew: string = "";
    parameterUrlActual: string = "";
    displayedColumns: string[];
    selectedSingleRows = null;
    selectedMultiRows = [];
    pageSizeOptions = [];
    pageSize: number;
    pageInfo = { previousPageIndex: 0, pageIndex: 0, pageSize: 10, length: 0 };
    exportData = [];
    showLoading = true;
    isSomeDada: boolean;
    selectedKey: string;
    exportToExcelName: string;
}

export interface columnn {
    name: string;
    visible: boolean;
    type: string;
    dateFromToFilter: string[];
    dateMonthFilter: string;
    orderByArrow: string;
    fromToFilter: boolean;
    fromToFilterValues: string[];
    picklistTableName: string;
    picklistKey: string;
    picklistSelectedItems: string[];
    picklistColumn: string;
    picklistTable: any[];
    columnSearch: boolean;
    search: string;
    function: string;
    CSSClass: string;
    export: boolean;
    format: string;
    formular: boolean;
}

export class gridFilterColumnSettings {
    public name: string;
    public dateFromToFilter: string[];
    public dateMonthFilter: string;
    public orderByArrow: string;
    public fromToFilterValues: string;
    public picklistSelectedItems: string[];
    public search: string;

    public toGridColumnSettings(columns: any) {
        this.name = columns.name;
        this.dateFromToFilter = columns.dateFromToFilter;
        this.dateMonthFilter = columns.dateMonthFilter;
        this.fromToFilterValues = columns.fromToFilterValues;
        this.picklistSelectedItems = columns.picklistSelectedItems;
        this.search = columns.search;
    }

    public restoreGridSettings(columns: any) {
        columns.dateFromToFilter = this.dateFromToFilter;
        columns.dateMonthFilter = this.dateMonthFilter;
        columns.fromToFilterValues = this.fromToFilterValues;
        columns.picklistSelectedItems = this.picklistSelectedItems;
        columns.search = this.search;
    }

}


export class gridFilterSettings {
    public array: gridFilterColumnSettings[] = [];
    public orderColumns: any[];
    public orderColumnsArrow: any[];
    public pageInfo: any;

    constructor(columns: any[], gridParams: GridParameters) {

        for (var i = 0; i < columns.length; i++) {
            var item = new gridFilterColumnSettings();
            item.toGridColumnSettings(columns[i]);
            this.array.push(item);
        }
        if (gridParams != undefined) {
            this.orderColumns = gridParams.orderColumns;
            this.orderColumnsArrow = gridParams.orderColumnsArrow;
            this.pageInfo = gridParams.pageInfo;

        }


    }

    updateColumns(columns: any[],) {
        this.array.forEach(e => {
            e.restoreGridSettings(columns.filter(item => item.name == e.name));
        });
    }
}